import React, { useEffect, useState } from 'react';
import Layout from './layout';
import { getContacts, updateContact, deleteContact } from './api/contactApi';

function ContactPage() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showThumbsUp, setShowThumbsUp] = useState(false);
  const [archi, setArchi] = useState('archived');

  const fetchContacts = async (is_deleted=0) => {
    setLoading(true);
    setError('');
    try {
      setArchi(is_deleted ? 'active' : 'archived');
      const data = await getContacts(is_deleted);
      setContacts(data.contacts || data);
    } catch {
      setError('Failed to fetch contacts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to move this contact row?')) return;
    try {
      await deleteContact(id);
      fetchContacts();
    } catch {
      setError('Failed to delete contact');
    }
  };

  const handleReplyToggle = async (contact) => {
    const newValue = contact.is_replied_to ? 0 : 1;
    try {
      await updateContact(contact.id, { is_replied_to: newValue });
      setContacts(prev => prev.map(c => c.id === contact.id ? { ...c, is_replied_to: newValue } : c));
      if (newValue === 1) {
        setShowThumbsUp(true);
        setTimeout(() => setShowThumbsUp(false), 3000);
      }
    } catch {
      setError('Failed to update reply status');
    }
  };

  return (
    <Layout>
      <div className="container p-4">
        <div className="row">
          <div className='col-md-10'>
          <h2>Contact Us Queries</h2>
          </div>
          <div className='col-md-2'>
            <button className='btn btn-secondary'
            onClick={
              () => fetchContacts((archi === 'archived') ? 1 : 0)
            }>Show {archi}</button>
          </div>
        </div>
        
        {error && <div className="alert alert-danger">{error}</div>}
        {loading ? (
          <div>Loading...</div>
        ) : (
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Purpose</th>
                <th>Content</th>
                <th>Sender</th>
                <th>Replied?</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {contacts.length === 0 && (
                <tr><td colSpan={5} className="text-center">No contacts found.</td></tr>
              )}
              {contacts.map((contact) => (
                <tr key={contact.id}>
                  <td>{contact.purpose}</td>
                  <td>{contact.content}</td>
                  <td>{contact.sender}</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={!!contact.is_replied_to}
                        onChange={() => handleReplyToggle(contact)}
                      />
                      <label className="form-check-label ms-2">
                        {contact.is_replied_to ? 'Yes' : 'No'}
                      </label>
                    </div>
                  </td>
                  <td>
                    <button className="btn btn-sm btn-warning" onClick={() => handleDelete(contact.id)}>
                      {archi === 'archived' ? 'Archive' : 'Unarchive'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {showThumbsUp && (
        <img
          src="/img/thumbsup.png"
          alt="Thumbs Up"
          className="thumbs-up-animation"
        />
      )}
    </Layout>
  );
}

export default ContactPage; 